import React from 'react';
import './DashboardPreviewSection.css';

const DashboardPreviewSection = () => {
  return (
    <section className="how-we-do-it">
      <div className="how-we-do-it__container">
        <h2 className="how-we-do-it__title">
          How do we do it?
        </h2>

        <div className="how-we-do-it__video-wrapper">
          <iframe
            src="https://player.cloudinary.com/embed/?cloud_name=dsvywoswv&public_id=VIDEO_PLATAFORMA_-_Compressed_with_FlexClip_wtrl0k&profile=cld-default"
            title="How we do it video"
            allow="fullscreen; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        </div>
      </div>
    </section>
  );
};

export default DashboardPreviewSection;
